import type { ModelProvider } from "@timibot/core";

/** 模型服务的中文名和排序：国内常用的排前面 */
export const ModelServiceNames = {
  order: ["deepseek", "qwen", "dashscope", "kimi", "moonshot", "glm", "zhipu", "z.ai", "minimax", "doubao", "volc", "ark", "xiaomi", "tencent", "hunyuan", "baidu", "openrouter"],
  title(p: ModelProvider): string {
    const n = p.name.toLowerCase();
    if (p.slug === "custom" || n === "custom endpoint") return "自定义接口";
    if (n.includes("qwen") || n.includes("dashscope")) return "通义千问";
    if (n.includes("moonshot") || n.includes("kimi")) return p.slug.endsWith("-cn") ? "Kimi（国内）" : "Kimi";
    if (n.includes("glm") || n.includes("zhipu")) return "智谱 GLM";
    if (n.includes("xiaomi")) return "小米 MiMo";
    if (n.includes("tencent")) return p.name.replace("Tencent", "腾讯");
    if (n.includes("doubao") || n.includes("volc")) return "豆包（火山方舟）";
    if (n.includes("google ai studio") || n === "gemini") return "Google Gemini";
    return p.name;
  },
  rank(p: ModelProvider): number {
    const key = `${p.slug} ${p.name}`.toLowerCase();
    const i = this.order.findIndex((o) => key.includes(o));
    return i < 0 ? this.order.length : i;
  },
};
